import React from "react";
import { GatsbyImage } from "gatsby-plugin-image"

const Image = ({image}) => (
    <GatsbyImage imgClassName="rounded-3xl" className="min-w-full w-auto rounded-3xl shadow-xl mb-14" image={image.image.localFile.childImageSharp.gatsbyImageData} alt={image.image.alternativeText} />
)

export default Image